import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import './Login.css';

function Login() {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((e) => {
      console.error('Login error:', e);
    });
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Plant Patrol</h1>
          <p>Plant Control Management System</p>
        </div>

        <div className="login-content">
          <h2>Welcome</h2>
          <p>Sign in with your Microsoft account to access Plant Patrol</p>

          <button className="btn btn-primary login-button" onClick={handleLogin}>
            <svg
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: '0.5rem' }}
            >
              <rect width="10" height="10" fill="#F25022" />
              <rect x="11" width="10" height="10" fill="#7FBA00" />
              <rect y="11" width="10" height="10" fill="#00A4EF" />
              <rect x="11" y="11" width="10" height="10" fill="#FFB900" />
            </svg>
            Sign in with Microsoft
          </button>

          <div className="login-info">
            <p>ARTEMIS Technologies Zrt.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
